// Sometimes Algolia doesn't update the URL when the UI state changes, so we fall back to updating the URL manually
let timeoutId: NodeJS.Timeout
const FALLBACK_TIMEOUT = 1000

export function urlUpdateFallback(templatesItemRoute: string, url?: string) {
  clearTimeout(timeoutId)
  timeoutId = setTimeout(() => {
    if (window.location.pathname.startsWith(templatesItemRoute)) {
      return
    }

    if (url && window.location.href !== url) {
      window.history.pushState({}, '', url)
    }
  }, FALLBACK_TIMEOUT)
}
